const enviroment = {
    basename: '/',
    defaultPath: '/',
    neoURL: {
        local: 'http://localhost:3000',
        dev: 'https://appdev.neoapp.cloud',
        qa: 'https://appqa.neoapp.cloud',
        prod: 'https://app.neoapp.cloud',
    },
    adminURL: {
        local: 'http://localhost:3002',
        dev: 'https://admdev.neoapp.cloud',
        qa: 'https://admqa.neoapp.cloud',
        prod: 'https://adm.neoapp.cloud',
    },
    authURL: {
        local: 'http://localhost:3900/v1/',
        dev: 'https://apidev.neoapp.cloud/auth/v1/',
        qa: 'https://apiqa.neoapp.cloud/auth/v1/',
        prod: 'https://api.neoapp.cloud/auth/v1/',
    },
    loginURL: {
        local: 'http://localhost:3001/',
        dev: 'https://ssodev.neoapp.cloud/',
        qa: 'https://ssoqa.neoapp.cloud/',
        prod: 'https://sso.neoapp.cloud/',
    },
    adminApiURL: {
        local: 'http://localhost:4004/v1/',
        dev: 'https://apidev.neoapp.cloud/adm/v1/',
        qa: 'https://apiqa.neoapp.cloud/adm/v1/',
        prod: 'https://api.neoapp.cloud/adm/v1/',
    },
};

export default {
    ...enviroment,
    neoURL: enviroment.neoURL[process.env.REACT_APP_ENVIROMENT],
    adminURL: enviroment.adminURL[process.env.REACT_APP_ENVIROMENT],
    authURL: enviroment.authURL[process.env.REACT_APP_ENVIROMENT],
    loginURL: enviroment.loginURL[process.env.REACT_APP_ENVIROMENT],
    adminApiURL: enviroment.adminApiURL[process.env.REACT_APP_ENVIROMENT],
};
